<template>
<div class="chapter">
<div class="inner_page">
<div class="part" id="part1">
<h1 class="notextbelow"><a id="page5"></a>The Naked<br/>GOSPEL</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002halftitlepage.vue?fd68e562